export default "__VITE_ASSET__CyNCkSwE__"